import { useCart } from '../hooks/useCart';
import { useLang } from '../hooks/useLanguage';

function SidebarTickets() {
    const { cart } = useCart();
    const { getI18n } = useLang();
    return (
        <ul>
            {cart.map((ticket) => (
                <li key={`${ticket.ticketTypeId}-${ticket.ticketOptionId}`}>
                    {getI18n(ticket.ticketTypeName, ticket.ticketTypeNameI18n)}{' '}
                    {getI18n(ticket.ticketOptionName, ticket.ticketOptionNameI18n)}{' '}
                    <strong>({ticket.quantity})</strong>
                </li>
            ))}
        </ul>
    );
}

export default SidebarTickets;
